export default {
  computed: {
    imagePosition () {
      // セクションとパーツコンテナのIDがない場合は何もしない：パレットからパーツを追加した瞬間はこの分岐に入る
      if (!this.sectionId || !this.partsContainerId) return

      // 所属しているパーツコンテナを取得
      const partsContainer = this.$store.getters.findPartsContainer(this.sectionId, this.partsContainerId)
      if (!partsContainer) return

      // 画像パーツ以外の場合は何もしない：ポジションがないため
      if (!partsContainer.type.match(/^Image/)) return
      // 画像パーツ ロゴパーツの場合はnullを返す
      if (partsContainer.type === 'Image' || partsContainer.type === 'Logo') return null

      // 画像のポジションを取得
      const imagePartCount = partsContainer.parts.filter(part => part.type === 'Image').length
      const layoutType = partsContainer.layout_type
      let imagePart
      let imagePosition
      if (imagePartCount === 1) {
        // 画像数：1の場合
        imagePart = partsContainer.parts.find(part => part.type === 'Image')
        if (layoutType === 'vertical' && imagePart.table_id === 1) {
          // レイアウト[縦] テーブルID[1]：Top
          imagePosition = 'Top'
        } else if (layoutType === 'vertical' && (imagePart.table_id === 2 || imagePart.table_id === 3)) {
          // レイアウト[縦] テーブルID[2]または[3]：Bottom
          // 画像テキストの場合、スペーサーがあるので3のテーブルに入る
          imagePosition = 'Bottom'
        } else if (layoutType === 'horizontal' && imagePart.table_id === 1) {
          // レイアウト[横] テーブルID[1]：Left
          imagePosition = 'Left'
        } else if (layoutType === 'horizontal' && (imagePart.table_id === 2 || imagePart.table_id === 3)) {
          // レイアウト[横] テーブルID[2]または3：Right
          // 画像テキストの場合、スペーサーがあるので3のテーブルに入る
          imagePosition = 'Right'
        }
      } else if (imagePartCount > 1) {
        // 画像数：2以上の場合 → 画像パーツの位置を判定するために、代表でテーブルID[1]の画像パーツを取得
        imagePart = partsContainer.parts.find(part => part.type === 'Image' && part.table_id === 1)
        if (layoutType === 'vertical' && imagePart.order_id === 1) {
          // レイアウト[縦] 並び順[1]：Left
          imagePosition = 'Left'
        } else if (layoutType === 'vertical' && (imagePart.order_id === 2 || imagePart.order_id === 3)) {
          // レイアウト[縦] 並び順[2]または[3]：Right
          // 画像テキストの場合、スペーサーがあるので3番目に画像が入る
          imagePosition = 'Right'
        } else if (layoutType === 'horizontal' && imagePart.order_id === 1) {
          // レイアウト[横] 並び順[1]：Top
          imagePosition = 'Top'
        } else if (layoutType === 'horizontal' && (imagePart.order_id === 2 || imagePart.order_id === 3)) {
          // レイアウト[横] 並び順[2]または[3]：Bottom
          // 画像テキストの場合、スペーサーがあるので3番目に画像が入る
          imagePosition = 'Bottom'
        }
      }
      return imagePosition
    }
  }
}
